import MaintenanceRequestApi from "./MaintenanceRequestApi";

export default MaintenanceRequestApi;
